import React from "react";
import UsersModule from "../modules/Users";

function Users() {
  return <UsersModule />;
}

export default Users;
